import ActiveValue from "~types/ActiveValue";

function getLearnMoreLinks(id: number, valueList: Array<ActiveValue>) {
  const statementObj = valueList.filter(
    valueStatement => valueStatement.statementId === id
  );
  return statementObj[0].learnMoreLinks;
}

export default getLearnMoreLinks;